<template>
  <div>
    <t-form labelWidth="80px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
      <t-form-item label="图库选择">
        <div @click="showGallery" style="width: 168px; height: 160px">
          <t-image style="width: 100%;height: 100%;background: none"
            :src="attribute.url ? fileUrl + attribute.url : require('@/assets/logo.png')" fit="fill" />
        </div>
      </t-form-item>
      <t-form-item label="填充方式">
        <t-select v-model="attribute.fit" placeholder="请选择填充方式" size="small">
          <t-option label="fill" value="fill" />
          <t-option label="contain" value="contain" />
          <t-option label="cover" value="cover" />
          <t-option label="none" value="none" />
          <t-option label="scale-down" value="scale-down" />
        </t-select>
      </t-form-item>
      <!--      <t-form-item label="点击放大">
        <t-radio-group v-model="attribute.preview" size="small">
          <t-radio :value="true">是</t-radio>
          <t-radio :value="false">否</t-radio>
        </t-radio-group>
      </t-form-item>-->
      <t-form-item label="预览功能">
        <t-radio-group v-model="attribute.isPreview" size="small">
          <t-radio :value="true">开启</t-radio>
          <t-radio :value="false">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
     
      
      <t-form-item label="自动旋转">
        <t-radio-group v-model="attribute.autoRotate" size="small">
          <t-radio :value="true">开启</t-radio>
          <t-radio :value="false">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="自旋时长(s)">
        <t-input-number :min="1" :max="60" v-model="attribute.rotateDuration" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.bgColor" enableAlpha
          size="small" />
      </t-form-item>
      <t-form-item label="图片透明度">

        <t-input-number v-model="attribute.opacity" :max="1" :step="0.1" :decimal-places="1" :min="0" size="small" />

      </t-form-item>
      <t-form-item label="是否缓存">
        <t-radio-group v-model="cptDataForm.isCache" size="small">
          <t-radio :value="false">开启</t-radio>
          <t-radio :value="true">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="默认查询">
        <t-radio-group v-model="attribute.noQuery" size="small">
          <t-radio :value="false">开启</t-radio>
          <t-radio :value="true">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="层级">
        <t-input-number v-model="attribute.zIndex" size="small" />
      </t-form-item>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck" />
  </div>
</template>

<script>
import Gallery from "@/components/designer/gallery";
import { fileUrl } from '/env'
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-image-option",
  components: { Gallery, CptData },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
    refMap: Object,
  },
  data() {
    return {
      fileUrl
    }
  },
  methods: {
    showGallery() {
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl) {
      this.cptDataForm.dataText = JSON.stringify({ url: '' })
      this.attribute.url = fileUrl
      this.refMap[this.currentCpt.id].setValue('')
    }
  }
}
</script>

<style scoped></style>
